import { Link } from "react-router-dom";

export default function Clause() {
  return (
    <div className="w-full">
      <div className="w-full mx-auto container  bg-white px-[30px] py-[30px] pt-24 md:pt-28  ">
        <h1 className="text-3xl font-bold text-blue-600 mb-6 text-center">
          ĐIỀU KHOẢN SỬ DỤNG
        </h1>
        <p className="text-gray-700 mb-4">
          Cảm ơn bạn đã truy cập website{" "}
          <Link to="mailto:http://bluerise.com.vn">bluerise.com.vn</Link> Khi sử
          dụng trang web này, bạn đồng ý tuân thủ các điều khoản sử dụng sau
          đây. Vui lòng đọc kỹ trước khi tiếp tục truy cập.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
          1. Phạm vi điều khoản
        </h2>
        <p className="text-gray-700 mb-4">
          Những điều khoản này áp dụng cho tất cả người truy cập và sử dụng
          trang web Blue Rise. Bạn cam kết rằng mình đã đủ 18 tuổi hoặc được
          phép theo quy định pháp luật để sử dụng trang web này.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
          2. Quyền sở hữu trí tuệ
        </h2>
        <p className="text-gray-700 mb-4">
          Toàn bộ nội dung, hình ảnh, video, logo, và tên thương hiệu hiển thị
          trên website Blue Rise đều thuộc sở hữu của Blue Rise hoặc các đối tác
          có liên quan. Nghiêm cấm sao chép, sử dụng hoặc phân phối nội dung khi
          chưa có sự đồng ý bằng văn bản.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
          3. Sử dụng website
        </h2>
        <p className="text-gray-700 mb-4">
          Bạn chỉ được phép sử dụng website vào mục đích hợp pháp. Nghiêm cấm sử
          dụng website cho các hoạt động bất hợp pháp, bao gồm nhưng không giới
          hạn, việc truyền tải nội dung có hại, gian lận, hay vi phạm quyền của
          bên thứ ba.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
          4. Tài khoản người dùng
        </h2>
        <p className="text-gray-700 mb-4">
          Khi tạo tài khoản trên Blue Rise, bạn có trách nhiệm bảo mật thông tin
          đăng nhập và các hoạt động liên quan đến tài khoản của bạn. Blue Rise
          không chịu trách nhiệm cho bất kỳ tác hại nào phát sinh từ việc sử
          dụng tài khoản không đúng cách.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
          5. Chính sách bảo mật
        </h2>
        <p className="text-gray-700 mb-4">
          Blue Rise cam kết bảo vệ thông tin cá nhân của người dùng theo quy
          định của pháp luật Việt Nam. Vui lòng tham khảo{" "}
          <Link to="/chinh-sach" className="hover:text-blue-500">
            Chính sách bảo mật
          </Link>{" "}
          để biết thêm chi tiết.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
          6. Giới hạn trách nhiệm
        </h2>
        <p className="text-gray-700 mb-4">
          Blue Rise không chịu trách nhiệm với bất kỳ thiệt hại nào, dù trực
          tiếp hay gián tiếp, phát sinh từ việc sử dụng trang web. Blue Rise
          không đảm bảo website không có lỗi hoặc khả năng truy cập liên tục.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
          7. Thay đổi điều khoản
        </h2>
        <p className="text-gray-700 mb-4">
          Blue Rise có quyền thay đổi nội dung điều khoản sử dụng bất kỳ lúc nào
          mà không cần thông báo trước. Bạn có trách nhiệm thường xuyên kiểm tra
          để đảm bảo hiểu rõ và tuân theo điều khoản được đề cập đến trong phần
          này.
        </p>
      </div>
    </div>
  );
}
